var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V23H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 22.2812H6.29688C3.92375 22.2812 2 20.3575 2 17.9844V10.754C2 9.4137 2.62541 8.15025 3.69104 7.33745L9.53478 2.88034C11.0738 1.70656 13.2075 1.70656 14.7465 2.88034L20.5902 7.33745C21.6558 8.15025 22.2812 9.4137 22.2812 10.754V17.9844C22.2812 20.3575 20.3575 22.2812 17.9844 22.2812Z",
    stroke: "#5F5F60",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 10.2119L8.42116 14.4673C10.519 16.0656 13.4276 16.0656 15.5255 14.4673L21.1693 10.166",
    stroke: "#5F5F60",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9551V5.79883M14.5781 8.37696H9.42188",
    stroke: "#5F5F60",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitation);
export default __webpack_public_path__ + "static/media/IconInvitation.b6f65abb42371d93ca9d6c5e3c7c9b1e.svg";
export { ForwardRef as ReactComponent };